import React, {Component} from 'react';
import Title from '../base/title';
import Dropdown from '../base/dropdown';
import api from '../../utils/api';
import {InfoBox, GoogleMap, Marker, Polygon, StyledMapWithAnInfoBox, Wkt} from '../base/map';

export default class Station extends Component {

    constructor(props) {
        super(props);
        this.state = {
            opened: true,
            loader: ' loader-box',
            loadMap: false,
            marker: {
                PM: {}
            },
            zone: {
                SHELL: [],
                YPF: [],
                AXION: [],
                PETROBRAS: [],
                OTRAS: []
            },
            station: {
                zone: {
                    area: {}
                },
                company: {}
            },
            currentMarker: {}
        }
        this.removeItem = this.removeItem.bind(this);
        this.mapRender = this.mapRender.bind(this);
        this.loadMapData = this.loadMapData.bind(this);
        this.getKey = this.getKey.bind(this);
    }

    mapRender(props) {
        let _self = this;
        if (!props.loadMap) return '';

        let polygon = [];
        if (props.polygon) {
            let wkt = new Wkt.Wkt();
            wkt.read(props.polygon.split(';')[1]);
            wkt.toJson().coordinates[0][0].forEach(cord => {
                polygon.push({lat: cord[1], lng: cord[0]});
            });
        }


        let center = {lat: parseFloat(_self.state.station.latitude), lng: parseFloat(_self.state.station.longitude)};

        // let bocasKeys = Object.keys(props.bocas);
        // for (let i = 0; i < bocasKeys.length; i++) {
        //     for (let v = 0; v < props.bocas[bocasKeys[i]].length; v++) {
        //         center = {
        //             lat: parseFloat(props.bocas[bocasKeys[i]][v].latitude),
        //             lng: parseFloat(props.bocas[bocasKeys[i]][v].longitude)
        //         };
        //         break;
        //     }
        // }

        if (!center && props.prime_marker.id) center = {
            lat: parseFloat(props.prime_marker.latitude),
            lng: parseFloat(props.prime_marker.longitude)
        };
        if (!center && props.secondary_marker.id) center = {
            lat: parseFloat(props.secondary_marker.latitude),
            lng: parseFloat(props.secondary_marker.longitude)
        };

        return <GoogleMap defaultOptions={{styles: props.myStyle}} defaultZoom={14} defaultCenter={center}>
            {props.polygon && <Polygon path={polygon}/>}
            {props.prime_marker &&
            <Marker icon={{url: api.marker(props.prime_marker.brand.pm_map_marker)}} key={props.prime_marker.id}
                    position={{
                        lat: parseFloat(props.prime_marker.latitude),
                        lng: parseFloat(props.prime_marker.longitude)
                    }} onClick={() => {
                _self.setState({currentMarker: props.prime_marker});
            }}>

                {props.currentMarker.id === props.prime_marker.id && <InfoBox onCloseClick={() => {
                    _self.setState({currentMarker: {}});
                }} options={{closeBoxURL: '', enableEventPropagation: true}}>
                    <div className="info-box">
                        {props.brand &&
                        <h2>{props.brand.name.toLowerCase().includes('shell') ? ('Shell ' + props.global_code + ' (' + props.inscription_number + ')') : props.brand.name + " " + props.inscription_number}<span
                            onClick={() => {
                                _self.setState({currentMarker: {}});
                            }}>X</span></h2>}
                        <p>{props.prime_marker.address}</p>
                        <p className="mb-2">{props.prime_marker.company ? props.prime_marker.company.cuit : ''}</p>
                        {props.prime_marker.last_prices.map(price => {
                            return <p>{price.product_shortname} ${price.pvp ? price.pvp : " -"}</p>
                        })}
                    </div>
                </InfoBox>}

            </Marker>}
            {props.secondary_marker &&
            <Marker icon={{url: api.marker(props.prime_marker.brand.sm_map_marker)}} key={props.secondary_marker.id}
                    position={{
                        lat: parseFloat(props.secondary_marker.latitude),
                        lng: parseFloat(props.secondary_marker.longitude)
                    }} onClick={() => {
                _self.setState({currentMarker: props.secondary_marker});
            }}>
                {props.currentMarker.id === props.secondary_marker.id && <InfoBox onCloseClick={() => {
                    _self.setState({currentMarker: {}});
                }} options={{closeBoxURL: '', enableEventPropagation: true}}>
                    <div className="info-box">
                        <h2>{props.brand.name.toLowerCase().includes('shell') ? ('Shell ' + props.global_code + ' (' + props.inscription_number + ')') : props.brand.name + " " + props.inscription_number}<span
                            onClick={() => {
                                _self.setState({currentMarker: {}});
                            }}>X</span></h2>
                        <p>{props.secondary_marker.address}</p>
                        <p className="mb-2">{props.secondary_marker.company ? props.secondary_marker.company.cuit : ''}</p>
                        {props.secondary_marker.last_prices.map(price => {
                            return <p>{price.product_shortname} ${price.pvp ? price.pvp : " -"}</p>
                        })}
                    </div>
                </InfoBox>}

            </Marker>}
            {Object.keys(props.bocas).map(index => {
                return props.bocas[index].map(boca => {
                    return <Marker key={boca.id} icon={{url: api.marker(boca.brand.map_marker)}}
                                   position={{lat: parseFloat(boca.latitude), lng: parseFloat(boca.longitude)}}
                                   onClick={() => {
                                       _self.setState({currentMarker: boca});
                                   }}>
                        {props.currentMarker.id === boca.id && <InfoBox onCloseClick={() => {
                            _self.setState({currentMarker: {}});
                        }} options={{closeBoxURL: '', enableEventPropagation: true}}>
                            <div className="info-box">
                                <h2>{boca.brand.name.toLowerCase().includes('shell') ? ('Shell ' + boca.global_code + ' (' + boca.inscription_number + ')') : boca.brand.name + " " + boca.inscription_number}<span
                                    onClick={() => {
                                        _self.setState({currentMarker: {}});
                                    }}>X</span></h2>
                                <p>{boca.address}</p>
                                <p className="mb-2">{boca.company.cuit}</p>
                                {boca.last_prices && boca.last_prices.map(price => {
                                    return <p>{price.product_shortname} ${price.pvp ? price.pvp : " -"}</p>
                                })}
                            </div>
                        </InfoBox>}

                    </Marker>
                })
            })}
        </GoogleMap>
    }

    getKey(station) {
        let key = 'OTRAS';
        if (station.brand.name.indexOf('SHELL') >= 0) key = 'SHELL';
        else if (station.brand.name.indexOf('YPF') >= 0) key = 'YPF';
        else if (station.brand.name.indexOf('AXION') >= 0) key = 'AXION';
        else if (station.brand.name.indexOf('PETROBRAS') >= 0) key = 'PETROBRAS';
        return key;
    }

    loadMapData() {
        let _self = this;
        api.get('stations/id/' + this.props.station.id).then(resp => {
            let _zones = {
                SHELL: [],
                YPF: [],
                AXION: [],
                PETROBRAS: [],
                OTRAS: []
            };

            let pm = resp.data.is_prime_marker_off ? resp.data.is_prime_marker_off : false;
            let key = _self.getKey(resp.data);
            if (key && (!pm || (pm.id !== resp.data.id))) _zones[key].push(resp.data);

            if (resp.data.nearby_markets) {
                resp.data.nearby_markets.forEach(station => {
                    let key = _self.getKey(station);
                    if (key && (!pm || (pm.id !== station.id))) _zones[key].push(station);
                });
            }
            api.get('stations/id/' + this.props.station.id + '/complements/').then(resp2 => {
                if (resp2.data.five_kilometers_stations)
                    resp2.data.five_kilometers_stations.forEach(station => {
                        let key = _self.getKey(station);
                        if (key && (!pm || (pm.id !== station.id))) _zones[key].push(station);
                    });

                _self.setState({
                    station: resp.data,
                    marker: {
                        PM: pm
                    },
                    zone: _zones,
                    loader: '',
                    loadMap: true
                });
            });
        })
    }

    componentDidMount() {
        this.loadMapData();
    }

    removeItem(key, item) {
        for (let i = 0; i < this.state.zone[key].length; i++) {
            if (this.state.zone[key][i].id === item.id) {
                this.state.zone[key].splice(i, 1);
            }
        }
        this.setState({zone: this.state.zone});
    }

    goToStation = (id) => {
        window.location = '/analisis/estacion/' + id
    };

    render() {
        let _self = this;
        return <div className="row close-station">
            <div className="row station-header">
                <div className="col s12">
                    <div className="row">
                        <div className="col s4 no-gutter">
                            <span>Número de inscripción: {this.state.station.inscription_number}&nbsp;</span>
                        </div>
                        <div className="col s4 no-gutter">
                            <span>{this.state.station.address}&nbsp;</span>
                        </div>
                        <div className="col s4 no-gutter">
                            <span>CUIT {this.state.station.company ? this.state.station.company.cuit : ''}&nbsp;</span>
                        </div>
                    </div>
                </div>
            </div>
            <Title text="ESTACIONES CERCANAS" isOpen={_self.state.opened} toggle={() => {
                _self.setState({opened: !_self.state.opened}, function () {
                    if (_self.state.opened) _self.componentDidMount();
                });
            }} isGray={true} hasIcon={true}/>
            {this.state.opened && <div className="row">
                <div className="col s12">
                    <div className="row">
                        <div className="pumps">
                            <div className="col s5 no-gutter">
                                <div className="pumps-container">
                                    <Dropdown text='ES PRIMEMARKER DE:' items={[{}]} getItem={() => {
                                    }} noIcon/>
                                    <ul className='pumps-list'>
                                        {Object.keys(this.state.marker).map(markerKey =>
                                            <li key={markerKey}
                                                onClick={() => this.goToStation(_self.state.marker[markerKey].id)}>
                                                {_self.state.marker[markerKey].brand && <img alt=""
                                                                                             src={api.marker(_self.state.marker[markerKey].brand.pm_map_marker)}
                                                                                             className="fas fa-map-marker-alt"/>}
                                                <b>{_self.state.marker[markerKey].inscription_number ? _self.state.marker[markerKey].inscription_number : 'No posee'}</b>
                                                <span>{_self.state.marker[markerKey].address ? _self.state.marker[markerKey].address : '-'}</span>
                                                <span
                                                    className="distance">{_self.state.marker[markerKey].distance ? _self.state.marker[markerKey].distance : '-'}</span>
                                                <i className="holder"></i>
                                            </li>
                                        )}
                                    </ul>
                                    <Dropdown text='PERTENCE A LA ZONA DE INFLUENCIA:' items={[{}]} getItem={() => {
                                    }} noIcon/>
                                    {this.state.station.is_nearby_market_off && <ul className='pumps-list'>
                                        <li key={_self.props.station.id}>
                                            <i className={"fas fa-map-marker-alt shell"}/>
                                            <b>{this.state.station.is_nearby_market_off.id}</b>
                                            <span>{this.state.station.is_nearby_market_off.address}</span>
                                            <span
                                                className="distance">{this.state.station.is_nearby_market_off.distance ? this.state.station.is_nearby_market_off.distance : '-'}</span>
                                            <i className="holder"></i>
                                        </li>
                                    </ul>}
                                </div>
                            </div>
                            <div className="col s7 no-gutter">
                                <StyledMapWithAnInfoBox currentMarker={this.state.currentMarker}
                                                        renderMethod={this.mapRender} loadMap={this.state.loadMap}
                                                        polygon={this.state.station.zone ? this.state.station.zone.geom : false}
                                                        bocas={this.state.zone} prime_marker={this.state.marker.PM}
                                                        secondary_marker={this.state.marker.SM}/>
                                <div className="selected-data">
                                    <div className="row">
                                        <div className="col s4 no-gutter">
                                            <b>CLUSTER</b>
                                        </div>
                                        <div className="col s4 no-gutter">
                                            <b>PROVINCIA</b>
                                        </div>
                                        <div className="col s4 no-gutter">
                                            <b>&nbsp;</b>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col s4 no-gutter">
                                            <div className="selected-data-holder">
                                                <img alt="" src="/static/imgs/angle-right.svg"/>
                                                <span>{this.state.station.pricing_cluster ? this.state.station.pricing_cluster.name : '-'}</span>
                                            </div>
                                        </div>
                                        <div className="col s4 no-gutter">
                                            <div className="selected-data-holder">
                                                <img alt="" src="/static/imgs/angle-right.svg"/>
                                                <span>{this.state.station.province ? this.state.station.province.name : '-'}</span>
                                            </div>
                                        </div>
                                        <div className="col s4 no-gutter">
                                            <div className="selected-data-holder">&nbsp;</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
        </div>
    }

}


// WEBPACK FOOTER //
// ./src/containers/analisis/station.js